/**
 * Copyright © 2026 Adnuntius AS.
 */
import {AdnListHelperService} from '../common/controller/list-helper.service';
import {Component, Inject, OnInit} from '@angular/core';
import {BsModalRef} from 'ngx-bootstrap/modal';
import * as _ from 'lodash';

import template from './line-item-retail-product-modal.component.html';
import {LocalNetworkInfo} from '../../components/session/local-network-info';
import {CreativeResource} from '../../components/api/resources/resource/creative.resource';
import {ProductFeedResource} from '../../components/api/resources/resource/product-feed.resource';

@Component({
  standalone: false,
  selector: 'adn-line-item-retail-product-modal',
  template
})
export class LineItemRetailProductModalComponent implements OnInit {
  lineItemId: string;
  onComplete: () => void;

  list: any = {};
  validationErrors: any[] = [];
  createHook: (refLayout: any) => Promise<void>;

  constructor(
    public bsModalRef: BsModalRef,
    private readonly adnListHelper: AdnListHelperService,
    @Inject(ProductFeedResource) private readonly ProductFeed: any,
    @Inject(CreativeResource) private readonly Creative: any) {
  }

  ngOnInit(): void {
    this.adnListHelper.setUpList(this.list, this.ProductFeed, false, '', {
      baseTable: 'productFeed',
      paginate: false
    });

    const retailProductFields = [{label: 'name', param: 'itemTitle'}, 'brand', {param: '', label: 'image'}, 'price'];
    this.list.defaultFields = retailProductFields;
    this.list.sel = {selFields: this.list.defaultFields};

    const merchantGuide = LocalNetworkInfo.obtain().getMerchantGuide();
    this.createHook = (refLayout: any) => {
      if (!refLayout?.id) {
        return Promise.resolve();
      }
      const allPromises: any[] = [];
      _.forEach(this.list.bulkSelection, (rp: any) => {
        const merchantLink = merchantGuide[rp.merchantId].link;
        allPromises.push(this.Creative.retailAd(this.lineItemId, '', refLayout.id, merchantLink, rp.itemId));
      });
      return Promise.all(allPromises).then(() => {
        this.onComplete?.();
        this.bsModalRef.hide();
      });
    };
  }

  dismiss(): void {
    this.bsModalRef.hide();
  }
}
